import {createRouter, createWebHistory} from "vue-router";
import authRoutes from "../components/partners/auth/authRoutes";

const routes = [
    ...authRoutes
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    if (window.requires_approval && to.name !== 'approval') {
        return next({ name: 'approval' });
    }

    next();
});

export default router
